import {Nullable} from '@fl/cmsch-fe-library';

export const addAnimalsFromDBFormName = 'addAnimalsFromDB';

export interface AddAnimalsFromDBFormValues {
    animalListId: Nullable<number>;
}
